import util from "./util"
import businessUtil from './business/businessUtil'
import businessMode from './business/businessMode'

function getCountByExcelData(taskOriginData){
	//获取表头
	const data_headers = taskOriginData[0];
	//console.log(data_headers)

	const stationIndex = businessUtil.getColumnIndex(data_headers,'站数') || businessUtil.getColumnIndex(data_headers,'电梯层站[层]') || businessUtil.getColumnIndex(data_headers,'电梯站数');
	if(stationIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加站数'
		};
	}
	const machineTypeIndex = businessUtil.getColumnIndex(data_headers,'设备类别');
	if(machineTypeIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加设备类别'
		};
	}

	const companyNameIndex = businessUtil.getColumnIndex(data_headers,'使用单位');
	if(machineTypeIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加使用单位'
		};
	}

	const wbIndex = businessUtil.getColumnIndex(data_headers,'维保单位名称');
	if(machineTypeIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加维保单位名称'
		};
	}

	const locationIndex = businessUtil.getColumnIndex(data_headers,'设备所在地点');
	if(locationIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加设备所在地点'
		};
	}

	const planIndex = businessUtil.getColumnIndex(data_headers,'安排日期') || businessUtil.getColumnIndex(data_headers,'检验日期');
	if(planIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加安排日期'
		};
	}

	const typeIndex = businessUtil.getColumnIndex(data_headers,'检验/检测') || businessUtil.getColumnIndex(data_headers,'检验检测');
	if(typeIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加检验检测'
		};
	}

	const needPayIndex = businessUtil.getColumnIndex(data_headers,'是否需要缴费') || businessUtil.getColumnIndex(data_headers,'是否有缴费单');
	if(needPayIndex === ""){
		return {
			signal: 'error',
			result: '请在表中添加是否需要缴费'
		};
	}

	taskOriginData[0].push('交通费');
	taskOriginData[0].push('应收');
	taskOriginData[0].push('金额');
	taskOriginData[0].push('金额备注');

	const costIndex_1 = businessUtil.getColumnIndex(data_headers,'交通费');
	const costIndex_2 = businessUtil.getColumnIndex(data_headers,'应收');
	const costIndex_3 = businessUtil.getColumnIndex(data_headers,'金额');
	const costIndex_4 = businessUtil.getColumnIndex(data_headers,'金额备注');

	//let companyNameObject = new Map();
	let companyNameObject = {};
	let companyNameList = [];

	let resultList = [taskOriginData[0]];

	taskOriginData.forEach((item,index) => {
		//格式化时间
		if(index !== 0){
		  item.forEach((setDate,dateIndex) => {
		    if(new RegExp('日期|时间').test(data_headers[dateIndex])){
		      item[dateIndex] = util.formatExcelDate(setDate,"-");
		    }
		  })

		  //安排日期为空则无法计算费用
		  if(util.isEmpty(item[planIndex])){
		    item[costIndex_4] = "安排日期为空";
		  	resultList.push(item);
		  }
		  //需要收费才进行计算
		  if(item[needPayIndex] === '是'){
		    //1、先将费用和交通费计算出来
		    const zs = Number(item[stationIndex]);
		    let cost = 0;
		    let baseMoney = 989;
		    if(new RegExp('杂物').test(item[machineTypeIndex])){
		      baseMoney = 450.5;
		    }else if(new RegExp('液压').test(item[machineTypeIndex])){
		      baseMoney = 803.5
		    }else if(new RegExp('扶梯|人行道').test(item[machineTypeIndex])){
		      baseMoney = 996
		    }
		    
		    cost = _countMachineMoney(baseMoney,zs);
		    let location = _matchLocationCostNew(item[locationIndex]); 

		    if(new RegExp('幼儿园|中学|小学|福利院|敬老院|惠东县胜利学校|惠州一中').test(item[companyNameIndex])){
		      cost = Number(cost) / 2; //费用
		      location.cost = Number(location.cost) / 2; //路费
		    }

		    //先将费用赋值
		    item[costIndex_2] = String(cost);
		    //item[costIndex_4] = location.remark;

		    let timeKey = new Date(item[planIndex]).getTime();
		    let tempWb = item[wbIndex];
		    let tempLocation = location.place;
		    let tempType = item[typeIndex];
		    //以使用单位为键生成一个对象 :使用单位:安排时间:地址:维保:(数据,路费)
		    if(companyNameObject[item[companyNameIndex]]){ //若是有这个键，则继续深入
		      if(companyNameObject[item[companyNameIndex]][timeKey]){//若是时间一致，则继续深入
		        if(companyNameObject[item[companyNameIndex]][timeKey][tempLocation]){ //若是地址一致，则继续深入
		          if(companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]){ //若是维保一致，则追加数据
		            if(tempType === '检测'){
		              let tempList = companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'];
		              tempList.push(item);
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = tempList;

		              let tempCostJc = companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = Number(tempCostJc) + Number(item[costIndex_2]);
		            }else if(tempType === '检验'){
		              let tempList = companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'];
		              tempList.push(item);
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = tempList;

		              let tempCostJy = companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = Number(tempCostJy) + Number(item[costIndex_2]);
		            }

		          }else{//若是维保不一致，则创建并赋值
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb] = {};
		            //companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datas'] = [item];

		            if(tempType === '检测'){
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [item];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = item[costIndex_2];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = 0;
		            }else if(tempType === '检验'){
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [item];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = item[costIndex_2];
		              companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = 0;
		            }
		          }

		        }else{//若是地址不一致，则创建并赋值
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation] = {}
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation]['locationCost'] = location.cost;
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb] = {};
		          //companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datas'] = [item];

		          if(tempType === '检测'){
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [item];
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [];
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = item[costIndex_2];
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = 0;
		          }else if(tempType === '检验'){
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [item];
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [];
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = item[costIndex_2];
		            companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = 0;
		          }
		        }

		      }else{//若是时间不一致，则创建并赋值
		        companyNameObject[item[companyNameIndex]][timeKey] = {};
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation] = {};
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation]['locationCost'] = location.cost;
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb] = {};
		        //companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datas'] = [item];
		        
		        if(tempType === '检测'){
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [item];
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [];
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = item[costIndex_2];
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = 0;
		        }else if(tempType === '检验'){
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [item];
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [];
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = item[costIndex_2];
		          companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = 0;
		        }
		      }

		    }else{//若是没有这个键，则创建并赋值: 使用单位:安排时间:地址:维保:(数据,路费)
		      companyNameObject[item[companyNameIndex]] = {};
		      companyNameObject[item[companyNameIndex]][timeKey] = {};
		      companyNameObject[item[companyNameIndex]][timeKey][tempLocation] = {};
		      companyNameObject[item[companyNameIndex]][timeKey][tempLocation]['locationCost'] = location.cost;
		      companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb] = {};
		      //companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datas'] = [item];
		      
		      if(tempType === '检测'){
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [item];
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [];
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = item[costIndex_2];
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = 0;
		      }else if(tempType === '检验'){
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJy'] = [item];
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['datasJc'] = [];
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJy'] = item[costIndex_2];
		        companyNameObject[item[companyNameIndex]][timeKey][tempLocation][tempWb]['totalCostJc'] = 0;
		      }
		    }

		  }else if(item[needPayIndex] === '否'){
		    resultList.push(item);
		  }
		}
	})

	//console.log(companyNameObject);

	for(let [companyKey, companyValue] of Object.entries(companyNameObject)){

		for(let [timeKey,timeValue] of Object.entries(companyValue)){

		  for(let [locationKey,locationValue] of Object.entries(timeValue)){
		    //console.log(locationKey,locationValue);
		    let len = Object.keys(locationValue).length - 1;
		    let placeCost = Number(locationValue['locationCost']) / len;

		    for(let [wbKey,wbValue] of Object.entries(locationValue)){
		      if(wbKey !== 'locationCost'){
		        let datasJy = wbValue['datasJy'];
		        let datasJc = wbValue['datasJc'];
		        let totalCostJc = wbValue['totalCostJc'];
		        let totalCostJy = wbValue['totalCostJy'];
		        if(datasJy.length !== 0){
		          datasJy.forEach((jy,jy_index) => {
		            if(jy_index === 0){
		              jy[costIndex_1] = placeCost
		            }
		            jy[costIndex_3] = ((Number(totalCostJy) + Number(placeCost)) / datasJy.length).toFixed(4);
		          })
		          datasJc.forEach((jc,jc_index) => {
		            //jc[costIndex_3] = Number(totalCostJc);
		            jc[costIndex_3] = Number(jc[costIndex_2])
		          })
		        }else{
		          datasJc.forEach((jc,jc_index) => {
		            if(jc_index === 0){
		              jc[costIndex_1] = placeCost;
		              //jc[costIndex_3] = (Number(totalCostJc) + Number(placeCost))
		              jc[costIndex_3] = (Number(jc[costIndex_2]) + Number(placeCost))
		            }
		            else{
		              jc[costIndex_3] = Number(jc[costIndex_2]) 
		            }
		          })
		        }
		        resultList = resultList.concat(datasJy);
		        resultList = resultList.concat(datasJc);
		      }  
		    }
		  }
		}
	}

	return {
		signal: 'success',
		result: resultList
	};
}

function _countMachineMoney(baseMoney,zs){
	let hasPoint = false;
	if(String(baseMoney).includes('.')){
		hasPoint = true;
	}
	let cost = baseMoney;
	if(zs - 7 > 0){
		cost = Math.floor(( ( ( zs - 7 ) * 0.06 ) + 1 ) * baseMoney);
	}

	if(hasPoint){
		cost + 0.5;
	}

	return cost;
}

function _matchLocationCostNew(location){
	let cost = 0;
	let place = "";
	let remark = "";
	let locationMap = businessMode.TRAVEL_COST_NEW;
	let subLocationMap = [];

	if(location.includes('惠城')) subLocationMap = locationMap['惠城'];
	else if(location.includes('大亚湾')) subLocationMap = locationMap['大亚湾'];
	else if(location.includes('仲恺')) subLocationMap = locationMap['仲恺'];
	else if(location.includes('惠阳')) subLocationMap = locationMap['惠阳'];
	else if(location.includes('惠东')) subLocationMap = locationMap['惠东'];
	else if(location.includes('龙门')) subLocationMap = locationMap['龙门'];
	else if(location.includes('博罗')) subLocationMap = locationMap['博罗'];
	else if(location.includes('深圳')) subLocationMap = locationMap['深圳'];
	else if(location.includes('广州')) subLocationMap = locationMap['广州'];

	for(let i = 0;i < subLocationMap.length;i++){
		if(location.includes(subLocationMap[i].place)){
		  cost = subLocationMap[i].cost;
		  place = subLocationMap[i].place
		  break;
		}
	}

	if(cost === 0){
		if(location.includes('仲恺')) cost = 36;
		else if(location.includes('惠阳')) cost = 64;
		else if(location.includes('惠东')) cost = 115;
		else if(location.includes('龙门')) cost = 262;
		else if(location.includes('博罗')) cost = 99;
		remark = "未设置该地址费用，自动按照该区域最低标准结算交通费";
	}
	if(place === ""){
		if(location.includes('仲恺')) place = '仲恺';
		else if(location.includes('惠阳')) place = '惠阳';
		else if(location.includes('惠东')) place = '惠东';
		else if(location.includes('龙门')) place = '龙门';
		else if(location.includes('博罗')) place = '博罗';
	}
	return {cost,place,remark};
}

function _matchLoactionCost(location){
	let cost = 0;
	let place = "";
	let remark = "";

	if(location.includes('惠城')) place = "惠城";
	else if(location.includes('大亚湾')) place = "大亚湾";
	else {
	let locationMap = businessMode.TRAVEL_COST;
	for(let i = 0;i < locationMap.length;i++){
	  if(location.includes(locationMap[i].place)){
	    cost = locationMap[i].cost;
	    place = locationMap[i].place
	    break;
	  }
	}
	if(cost === 0){
	  if(location.includes('仲恺')) cost = 36;
	  else if(location.includes('惠阳')) cost = 64;
	  else if(location.includes('惠东')) cost = 115;
	  else if(location.includes('龙门')) cost = 262;
	  else if(location.includes('博罗')) cost = 99;
	  remark = "未设置该地址费用，自动按照该区域最低标准结算交通费";
	}
	if(place === ""){
	  if(location.includes('仲恺')) place = '仲恺';
	  else if(location.includes('惠阳')) place = '惠阳';
	  else if(location.includes('惠东')) place = '惠东';
	  else if(location.includes('龙门')) place = '龙门';
	  else if(location.includes('博罗')) place = '博罗';
	}
	}
	return {cost,place,remark};
}

export default {
	getCountByExcelData
}


//////////////////
// WEBPACK FOOTER
// ./static/calculate.js
// module id = null
// module chunks = 